

@if (loaded) {
@for (field of question.fields; track field.id) {
	<div>
	@switch (field.type) {
		@case ('number') {
			<div class="label-container">
				<label class="title">{{ field.text | cTranslate }}</label>
				@if (field.value) {
					<label class="value text-accent-alt">#{{ field.value }}</label>
				}
			</div>
			<div class="d-flex justify-content-center">
				<mat-slider class="slider-accent-alt"
					[max]="field.max"
					[min]="field.min"
					[step]="1"
					[discrete]="true"
					[showTickMarks]="false">
					<input matSliderThumb [(ngModel)]="field.value">
				</mat-slider>
			</div>
		}
		@case ('count') {
			<div class="label-container">
				<label class="title">{{ field.text | cTranslate }}</label>
			</div>

			<div class="input-group input-group-count mb-3 mt-2">
				<div class="input-group-prepend">
					<button class="btn btn-secondary" type="button" (click)="fieldIncrement(field,-1)" [disabled]="!field.value">
						<mat-icon svgIcon="minus"></mat-icon>
					</button>
				</div>
				<input type="text" class="form-control"  [(ngModel)]="field.value" readonly>
				<div class="input-group-append">
					<button class="btn btn-secondary" type="button" (click)="fieldIncrement(field,1)" [disabled]="field.value >= field.max">
						<mat-icon svgIcon="plus"></mat-icon>
					</button>
				</div>
			</div>
		}
		@case ('toggle') {
			<div class="label-container">
				<label class="title">{{ field.text | cTranslate }}</label>
			</div>

			<div class="mb-3 mt-2">
				<div class="btn-group d-flex">
					@for (item of generateRange(field); track $index) {
						<button  type="button" class="btn" [ngClass]="field.value === (field.min + $index) ? 'btn-secondary' : 'btn-outline-dark'" (click)="field.value = field.min + $index">
							{{ field.min + $index }}
						</button>
					}
				</div>
			</div>

		}
		@case ('amount') {
			<div class="label-container ">
				<label class="title">{{ field.text | cTranslate }}</label>
				<label class="value text-accent-alt">{{field.value | lcurrency}}</label>
			</div>
			<div class="d-flex justify-content-center">
				<mat-slider class="slider-accent-alt"
					color="primary"
					[max]="field.max"
					[min]="field.min"
					[step]="field.step"
					[discrete]="true"
					[showTickMarks]="false">
					<input matSliderThumb [(ngModel)]="field.value" >
				</mat-slider>
			</div>
		}
		@case ('chips') {
			<div class="label-container mb-1">
				<label class="title">{{ field.text | cTranslate }}</label>
			</div>
			<div class="_chip-set mb-1">
				@for (chip of field.members; track chip.id) {
					<div class="_chip accent-alt" [class.active]="field.value.includes(chip.value)" (click)="toggleChip(field, chip.value)">
						<span>{{ chip.value | cTranslate }}</span>
					</div>
				}
			</div>
		}
	}
	</div>
}
	<div class="text-far pb-4 mt-3">
		<!--<button type="button" class="btn btn-accent-alt" (click)="_apply()">
			{{'tabot.find_me' | translate}}
		</button>-->
		<button type="button" matButton="outlined"  class="accent-alt" (click)="_apply()" style="min-width: 160px">
			{{'apply_search' | cTranslate}}
		</button>
	</div>

}
